/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { GridContext as o } from "../GridClientWrapper.mjs";
import { pagerMessagesMap as a } from "../messages/messagesMap.mjs";
import { cloneReactElement as n } from "../utils/index.mjs";
const s = (r) => {
  const e = t.useContext(o);
  return n(r.children, {
    onPageChange: e.pagerPageChange,
    messagesMap: a,
    dir: e.dir
  });
};
export {
  s as PagerContainer
};
